module.exports = __webpack_public_path__ + "img/ssic.55791ddd.png";